/** Public messages are selected by status, never copied from an exception or provider response. */
export const TEMPORARY_UNAVAILABLE = 'This service is temporarily unavailable. Please try again shortly.';
export const USAGE_LIMIT_MESSAGE = 'The usage limit has been reached. Please try again later.';

export function publicFailureMessage(status = 503): string {
  if (status === 429) return USAGE_LIMIT_MESSAGE;
  if (status === 404 || status === 410) return 'That item is not available.';
  if (status === 413) return 'That file or recording is too large. Please try a smaller one.';
  if (status >= 400 && status < 500) return 'We could not complete that request. Please check it and try again.';
  return TEMPORARY_UNAVAILABLE;
}

/** Public response metadata never carries model identifiers, retry failures or debug objects. */
export function publicAskResponse<T extends { engine?: string }>(body: T): T {
  const out = { ...body } as T & { engine?: string; debug?: unknown; draft?: unknown; plan?: unknown; evidence?: unknown };
  delete out.debug;
  delete out.draft;
  delete out.plan;
  delete out.evidence;
  if (out.engine?.startsWith('records (')) out.engine = 'records';
  else if (out.engine && /@|\b(?:after|retry|error|workers|cloudflare)\b/i.test(out.engine)) out.engine = 'assistant';
  return out;
}
